import React, { Component } from 'react'
import PropTypes from 'prop-types';
import { ActionIconsTwo, CallBtn, CallHandlingBox, Decline, IconRow } from '../styles/dialpadstyle'
import { Button } from 'modules/theme';

export class BardgeButton extends Component {
  render() {
    const {
      monitorState,
      labelMonitorCustomer,
      labelMonitorAgent,
      labelMonitorListen,
      monitorCustomer,
      monitorAgent,
      monitorListen,
      iconCustomer,
      iconAgent,
      iconListen,
      onClickBtn,
      monitorBoth,
      iconBoth,
      labelMonitorBoth,
      btn
    } = this.props;
    return (
      <div>
        <CallHandlingBox>
          <IconRow>
            <ActionIconsTwo>
              <a style={{cursor: "pointer"}} onClick={monitorCustomer}>
                <i style={ monitorState == "customer" ? { "background":"#0161ED","color":"#fff"} : {}}>
                  {iconCustomer}
                </i>
                <label>{labelMonitorCustomer}</label>
              </a>
            </ActionIconsTwo>
            <ActionIconsTwo>
              <a style={{cursor: "pointer"}} onClick={monitorAgent}>
                <i style={ monitorState == "agent" ? { "background":"#0161ED","color":"#fff"} : {}}>
                  {iconAgent}
                </i>
                <label>{labelMonitorAgent}</label>
              </a>
            </ActionIconsTwo>
          </IconRow>
          <IconRow>
            <ActionIconsTwo>
                <a style={{cursor: "pointer"}} onClick={monitorBoth}>
                  <i style={ monitorState == "both" ? { "background":"#0161ED","color":"#fff"} : {}}>
                    {iconBoth}
                  </i>
                  <label>{labelMonitorBoth}</label>
                </a>
              </ActionIconsTwo>
              <ActionIconsTwo>
                <a style={{cursor: "pointer"}} onClick={monitorListen}>
                  <i style={ monitorState == "listen" ? { "background":"#0161ED","color":"#fff"} : {}}>
                    {iconListen}
                  </i>
                  <label>{labelMonitorListen}</label>
                </a>
              </ActionIconsTwo>
          </IconRow>
          <CallBtn>
            <Decline style={{width: '100%'}}>
              <i style={{cursor: "pointer"}} onClick={onClickBtn}>
                <img src={btn} />
              </i>
            </Decline>
          </CallBtn>
          {/* <div className="circle">
            <img src="/images/BiDialpadAlt.png" style={{ padding: '13px' }} />
          </div>
          <div className="circle">
            <img
              onClick={this.callHoldToggle}
              src="/images/AiOutlineUserAdd.png"
            />
          </div>
          <div className="circle">
            <img
              onClick={this.callMuteToggle}
              src="/images/AiOutlinePause.png"
            />
          </div>
          <div className="circle">
            <img src="/images/MdEditNote.png" />
          </div> */}
        </CallHandlingBox>
        
      </div>
    )
  }
}

BardgeButton.propTypes = {
  isConnected: PropTypes.bool.isRequired
};

BardgeButton.contextTypes = {
  __: PropTypes.func
};

export default BardgeButton


// WEBPACK FOOTER //
// ./src/modules/theme/theme1/common/components/BardgeButton.js